// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* La hoja de oferta (LAKPED-16.4): la usan la página del PDF y el pop-up de vista previa (LAKPED-23). */
.offer-pdf-hoja {
  background: #fff;
  border: 1px solid #ccc;
  box-shadow: 0 4px 18px #0002;
  padding: 44px 52px;
  min-height: 640px;
  font-size: 13px;
}

.offer-pdf-cabecera {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  border-bottom: 2px solid #111;
  padding-bottom: 14px;
  margin-bottom: 20px;
}

.offer-pdf-logo { max-height: 46px; }

.offer-pdf-titulo h1 { font-size: 24px; font-weight: 700; margin: 0; color: #111; }
.offer-pdf-titulo span { display: block; margin-top: 6px; font-size: 13px; color: #333; }

.offer-pdf-datos { font-size: 13px; color: #333; line-height: 1.7; }
.offer-pdf-datos span { font-weight: 600; color: #111; }

.offer-pdf-tabla { width: 100%; border-collapse: collapse; margin: 16px 0; font-size: 13px; }
.offer-pdf-tabla th {
  background: #f0f0f0;
  text-align: left;
  font-size: 12px;
  font-weight: 600;
  color: #333;
  padding: 7px 9px;
}
.offer-pdf-tabla td { padding: 8px 9px; border-bottom: 1px solid #ddd; color: #222; }
.offer-pdf-tabla th.der, .offer-pdf-tabla td.der { text-align: right; }

.offer-pdf-total { text-align: right; font-size: 15px; color: #111; margin: 0; }

.offer-pdf-condiciones {
  margin: 28px 0 0;
  font-size: 13px;
  color: #444;
  white-space: pre-line;
}

@media print {
  .offer-pdf-hoja { border: none; box-shadow: none; padding: 0; min-height: 0; }
  .offer-pdf-tabla { page-break-inside: auto; break-inside: auto; }
  .offer-pdf-tabla tr { page-break-inside: avoid; break-inside: avoid; }
  .offer-pdf-tabla th { print-color-adjust: exact; }
}
`, "",{"version":3,"sources":["webpack://./src/components/Offers/OfferSheet.css"],"names":[],"mappings":"AAAA,wGAAwG;AACxG;EACE,gBAAgB;EAChB,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,6BAA6B;EAC7B,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,kBAAkB,gBAAgB,EAAE;;AAEpC,uBAAuB,eAAe,EAAE,gBAAgB,EAAE,SAAS,EAAE,WAAW,EAAE;AAClF,yBAAyB,cAAc,EAAE,eAAe,EAAE,eAAe,EAAE,WAAW,EAAE;;AAExF,mBAAmB,eAAe,EAAE,WAAW,EAAE,gBAAgB,EAAE;AACnE,wBAAwB,gBAAgB,EAAE,WAAW,EAAE;;AAEvD,mBAAmB,WAAW,EAAE,yBAAyB,EAAE,cAAc,EAAE,eAAe,EAAE;AAC5F;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;AACA,sBAAsB,gBAAgB,EAAE,6BAA6B,EAAE,WAAW,EAAE;AACpF,mDAAmD,iBAAiB,EAAE;;AAEtE,mBAAmB,iBAAiB,EAAE,eAAe,EAAE,WAAW,EAAE,SAAS,EAAE;;AAE/E;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,kBAAkB,YAAY,EAAE,gBAAgB,EAAE,UAAU,EAAE,aAAa,EAAE;EAC7E,mBAAmB,uBAAkB,EAAlB,kBAAkB,EAAE;EACvC,sBAAsB,wBAAmB,EAAnB,mBAAmB,EAAE;EAC3C,sBAAyD,yBAAyB,EAAE;AACtF","sourcesContent":["/* La hoja de oferta (LAKPED-16.4): la usan la página del PDF y el pop-up de vista previa (LAKPED-23). */\n.offer-pdf-hoja {\n  background: #fff;\n  border: 1px solid #ccc;\n  box-shadow: 0 4px 18px #0002;\n  padding: 44px 52px;\n  min-height: 640px;\n  font-size: 13px;\n}\n\n.offer-pdf-cabecera {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 20px;\n  border-bottom: 2px solid #111;\n  padding-bottom: 14px;\n  margin-bottom: 20px;\n}\n\n.offer-pdf-logo { max-height: 46px; }\n\n.offer-pdf-titulo h1 { font-size: 24px; font-weight: 700; margin: 0; color: #111; }\n.offer-pdf-titulo span { display: block; margin-top: 6px; font-size: 13px; color: #333; }\n\n.offer-pdf-datos { font-size: 13px; color: #333; line-height: 1.7; }\n.offer-pdf-datos span { font-weight: 600; color: #111; }\n\n.offer-pdf-tabla { width: 100%; border-collapse: collapse; margin: 16px 0; font-size: 13px; }\n.offer-pdf-tabla th {\n  background: #f0f0f0;\n  text-align: left;\n  font-size: 12px;\n  font-weight: 600;\n  color: #333;\n  padding: 7px 9px;\n}\n.offer-pdf-tabla td { padding: 8px 9px; border-bottom: 1px solid #ddd; color: #222; }\n.offer-pdf-tabla th.der, .offer-pdf-tabla td.der { text-align: right; }\n\n.offer-pdf-total { text-align: right; font-size: 15px; color: #111; margin: 0; }\n\n.offer-pdf-condiciones {\n  margin: 28px 0 0;\n  font-size: 13px;\n  color: #444;\n  white-space: pre-line;\n}\n\n@media print {\n  .offer-pdf-hoja { border: none; box-shadow: none; padding: 0; min-height: 0; }\n  .offer-pdf-tabla { break-inside: auto; }\n  .offer-pdf-tabla tr { break-inside: avoid; }\n  .offer-pdf-tabla th { -webkit-print-color-adjust: exact; print-color-adjust: exact; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
